<template>
  <div class="default-title">
      <el-form label-width="80px" :model="form" class="list-top-margin production-progress">
        <el-row>
          <el-col :span="8">
            <el-form-item label="工序编号">
              <el-input size="small" v-model="form.processCode" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工序名称" >
              <el-input size="small" v-model="form.processName" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4" class="text-align-right">
            <el-form-item label-width="20px">
              <el-button size="mini" type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table ref="tableData" size="small" :data="listData"
      highlight-current-row v-loading="loading" max-height="400px"
      stripe border element-loading-text="拼命加载中" :header-cell-style="_headerStyle"
      style="width: 100%;"  @selection-change="handleSelectionChange"
      row-key="_id">
        <el-table-column type="selection" width="60" :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="processCode" label="工序编号">
        </el-table-column>
        <el-table-column prop="processName" label="工序名称">
        </el-table-column>
        <el-table-column prop="userNameList" label="报工权限">
          <template slot-scope="scope">
            <div>{{scope.row.userNameList && scope.row.userNameList.join(',')}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="coefficient" label="报工数配比"></el-table-column>
        <el-table-column prop="nongoodNameList" label="不良品项列表"></el-table-column>
      </el-table>
       <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <div slot="footer" class="text-align-center" style="position: relative;">
        <div class="select-count-content">已选{{selectCount}}项</div>
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" class="title" @click="save">保 存</el-button>
      </div>
  </div>
</template>
<script>
import { processGetList} from '@/api/basicData'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      buttonSize:'small',
      form:{
        processCode:''
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      loading:false,
      selectCount:0,
      userData:{}
    }
  },
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
    }
    this.getdata()
  },
  methods:{
    search(){
      this.pageparm.currentPage =1;
      this.pageparm.pageSize = 10;
      this.getdata()
    },
    getdata() {
      this.loading = true
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
          processCode: this.form.processCode,
          processName: this.form.processName,
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      processGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total || 0;
          for(var i = 0;i<res.data.list.length;i++){
            res.data.list[i]['type'] = 'process';
          }
          this.listData = res.data.list
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    cancel(){
      this.$emit('done',{type:'cancel'})
    },
    save(){

      var selection = this.$refs.tableData.selection
      this.$emit('done',{type:'save',data:selection});
    },
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata()
    },
    handleSelectionChange(){
      this.selectCount = this.$refs.tableData.selection.length
    },
  }
}
</script>
<style>
.production-progress .el-input-group__append,
.production-progress .el-input-group__prepend{
  color: #fff;
  background-color: #409EFF!important;
  border-radius: 0 4px 4px 0;
}
.select-count-content{
  position: absolute;
  left: 0;
  top: -45px;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/views/order/dialogManage/production-processes.vue